import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import isEmpty from 'lodash/isEmpty';
import { styled } from '@mui/system';
import MuiGrid from '@mui/material/Grid';
import MuiFormLabel from '@mui/material/FormLabel';
import Tooltip from '@cpg-its/ads.common.tooltip';
import Typography from '@cpg-its/ads.common.typography';
import { blue, red } from '@cpg-its/ads.constants.colors';
const StyledFormLabel = styled(MuiFormLabel)({
    color: red,
    marginLeft: '0.25rem',
});
const SubLabelWrapper = styled(MuiGrid)({
    margin: '.5rem 0',
});
const TooltipWrapper = styled(MuiGrid)({
    display: 'inline-flex',
    marginLeft: '2rem',
    position: 'absolute',
});
const FormLabelComponent = ({ label, required, subLabel, tooltip, }) => {
    const renderLabel = (() => {
        if (label) {
            return (_jsx(Typography, { extraBold: true, component: "span", text: label }));
        }
        return null;
    })();
    const renderSubLabel = (() => {
        if (subLabel) {
            return (_jsx(SubLabelWrapper, { children: _jsx(Typography, { text: subLabel }) }));
        }
        return null;
    })();
    const renderTooltip = (() => {
        if (!isEmpty(tooltip)) {
            const { iconColor, backgroundColor, title } = tooltip;
            return (_jsx(TooltipWrapper, { children: _jsx(Tooltip, { iconColor: iconColor || blue, backgroundColor: backgroundColor, title: title }) }));
        }
        return null;
    })();
    return (_jsxs(StyledFormLabel, { required: required, children: [renderLabel, renderTooltip, renderSubLabel] }));
};
export default FormLabelComponent;
//# sourceMappingURL=form-label.js.map